import { BaseModalComponent } from './../base/base-modal.component';
import { FormGenModel } from './../../../../../shared/models/form-gen.model';
import { Component, OnInit } from '@angular/core';
import { FormGroup, FormControl, Validators } from '@angular/forms';
import { ModalController } from '@ionic/angular';

export const GENDER_LIST: FormGenModel[] = [
  { label: 'MALE', value: 'MALE' },
  { label: 'FEMALE', value: 'FEMALE' },
  { label: 'OTHER', value: 'OTHER' },
];

@Component({
  selector: 'inc-gender',
  templateUrl: './gender.component.html'
})
export class GenderComponent extends BaseModalComponent implements OnInit {
  title = 'GENDER';
  formGenList = GENDER_LIST;

  constructor(modalController: ModalController) {
    super(modalController);
    this.reset(new FormGroup({
      gender: new FormControl('OTHER', Validators.required)
    }));
  }

  save() {
    this.baseSave({ value: { gender: this.form.controls.gender } });
  }
}
